import {Injectable} from '@angular/core';
import {LanguageEnum} from '@core/enums/language.enum';
import {LanguageStyleEnum} from '@core/enums/language-style.enum';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class ConversionsService {

    constructor(private translate: TranslateService) {
    }

    getMinutesFromMillis(millis: number): string {
        if (millis < 60000) {
            return '1';
        }
        return (millis / (1000 * 60)).toFixed(0);
    }

    getMinutesStringFromMillis(millis: number): string {
        const seconds = Math.floor((millis / 1000) % 60);
        const minutes = Math.floor((millis / (1000 * 60)) % 60);
        const hours = Math.floor((millis / (1000 * 60 * 60)) % 24);

        const hoursString = (hours < 10) ? '0' + hours : hours;
        const minutesString = (minutes < 10) ? '0' + minutes : minutes;
        const secondsString = (seconds < 10) ? '0' + seconds : seconds;

        return hoursString + ':' + minutesString + ':' + secondsString;
    }

    getLanguageFromEnumInLanguage(word: LanguageEnum): string {
        if (word === LanguageEnum.GERMAN) {
            return this.translate.instant('GENERAL.GERMAN');
        }
        return this.translate.instant('GENERAL.ENGLISH');
    }

    getLanguageStyleFromEnumInLanguage(languageStyle: LanguageStyleEnum): string {
        switch (languageStyle) {
            case LanguageStyleEnum.EASY:
                return this.translate.instant('ONBOARDING.LANGUAGE_STYLE.EASY_TITLE');
            case LanguageStyleEnum.SIMPLE:
                return this.translate.instant('ONBOARDING.LANGUAGE_STYLE.SIMPLE_TITLE');
            default:
                return this.translate.instant('ONBOARDING.LANGUAGE_STYLE.STANDARD_TITLE');
        }
    }
}
